// src/pages/About.js
import React, { useEffect, useState } from "react";
import baseURL from '../config';

const About = () => {
  const [aboutData, setAboutData] = useState(null);

  document.title = "About Us - My Website";

  useEffect(() => {
    fetch(`${baseURL}/api/about-us/`)
      .then((res) => res.json())
      .then((data) => setAboutData(data))
      .catch((err) => console.error("Error loading about data:", err));
  }, []);

  if (!aboutData) return <div className="text-center py-5">Loading...</div>;

  return (
    <section className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center mb-4">{aboutData.title || "About Us"}</h2>
        <div className="row justify-content-center">
          <div className="col-md-8">
            {aboutData.image && (
              <img
                src={aboutData.image}
                alt="About"
                className="img-fluid rounded mb-4"
              />
            )}
            <p className="lead text-muted">{aboutData.short_description}</p>
            <p>{aboutData.long_description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
